function throwError(name: string, message: string, constructor: Function) {
  const error = new Error();
  error.name = name;
  error.message = message;
  Error.captureStackTrace(error, constructor);
  throw error;
}

export { throwError };
